<div
  class="table-pagination bg-white dark:bg-dark-card border-slate-200 dark:border-dark-border border-l border-r border-b py-2 px-3 flex justify-between"
  [ngClass]="{ 'rounded-b-sm': !fullScreen }"
>
  <div class="flex items-center gap-2">
    <div *appIsEmpty class="flex items-center gap-2">
      <ng-content></ng-content>
    </div>
    <div class="table-pagination__index text-secondary dark:text-dark-muted font-normal text-xs flex items-center">
      {{ 'table.pagination.index' | translate: {
      start: dataLength === 0 ? 0 : (1 + ((currentPage - 1) * pageSize)),
      end: dataLength > (pageSize * currentPage) ? pageSize * currentPage : dataLength,
      total: dataLength
    } }}
    </div>
  </div>
  <div class="table-pagination__action flex">
    <button
      [disabled]="currentPage === 1"
      (click)="previousPage()"
      class="py-2 px-2 rounded-md bg-gray-100 dark:bg-dark-hover mr-2 disabled:bg-slate-50 disabled:text-slate-300 disabled:cursor-not-allowed"
    >
      <lucide-icon size="16" [name]="ChevronLeft"></lucide-icon>
    </button>
    <button
      [disabled]="currentPage * pageSize >= dataLength"
      (click)="nextPage()"
      class="py-2 px-2 rounded-md bg-gray-100 dark:bg-dark-hover disabled:bg-slate-50 disabled:text-slate-300 disabled:cursor-not-allowed"
    >
      <lucide-icon size="16" [name]="ChevronRight"></lucide-icon>
    </button>
  </div>
</div>
